export const mentoring = [
  {
    id: "cliffton-owen",
    name: "Cliffton Owen Gunawan",
    firstname: "Cliffton",
    designation: "Undergraduate Student, SUTD",
    duration: "Jun 2026 - Present",
    projectIds: [
      "review"
    ]
  },
  {
    id: "edward-chan",
    name: "Chan Jun Da Edward",
    firstname: "Edward",
    designation: "Undergraduate Student, SUTD",
    duration: "Feb 2026 - Present",
    projectIds: [
      "forge"
    ]
  },
  {
    id: "shuenn-yuen",
    name: "Han Shuenn Yuen",
    firstname: "Shuenn Yuen",
    designation: "Undergraduate Student, SUTD",
    duration: "Jan 2026 - Present",
    projectIds: [
      "waves"
    ]
  },
  {
    id: "arishya-jindal",
    name: "Arishya Jindal",
    firstname: "Arishya",
    designation: "Undergraduate Student, SUTD",
    duration: "May 2025 - Mar 2026",
    projectIds: [
      "trust"
    ]
  },
  {
    id: "skylar-looi",
    name: "Skylar Looi Yuxun",
    firstname: "Skylar",
    designation: "Undergraduate Student, SUTD",
    duration: "May 2025 - Mar 2026",
    projectIds: [
      "trust"
    ]
  },
  {
    id: "kaviraam",
    name: "Kaviraam S/O Thamotharam",
    firstname: "Kaviraam",
    designation: "Undergraduate Student, SUTD",
    duration: "Jan 2025 - Aug 2025",
    projectIds: [
      "forge"
    ]
  },
  {
    id: "manya-mehra",
    name: "Manya Mehra",
    firstname: "Manya",
    designation: "Undergraduate Student, SUTD",
    duration: "Jan 2025 - Aug 2025",
    projectIds: [
      "forge"
    ]
  },
  {
    id: "vadora-tang",
    name: "Vadora Tang Wan Ni",
    firstname: "Vadora",
    designation: "Undergraduate Student, SUTD",
    duration: "Jan 2025 - Aug 2025",
    projectIds: [
      "sense"
    ]
  },
  {
    id: "hugo-chen",
    name: "Hugo Chen",
    firstname: "Hugo",
    designation: "Undergraduate Student, SUTD",
    duration: "Sep 2024 - Mar 2025",
    projectIds: [
      "sense",
      "empathai"
    ]
  },
  {
    id: "owen-sengdalavong",
    name: "Sengdalavong Palinya (Owen)",
    firstname: "Owen",
    designation: "Undergraduate Student, SUTD",
    duration: "Sep 2024 - Apr 2025",
    projectIds: [
      "heartalk"
    ]
  }
];
